<template>
    <div class="position-relative">
        <div
            v-if="description"
            class="font-weight-light font--14 mb-10 pb-20"
            v-html="description"
        />

        <div
            class="d-flex"
            :class="$mq.sMinus && 'flex-column'"
        >
            <div
                v-if="showTemplate"
                :class="$mq.sMinus ? 'w-100 mb-20' : 'w-50 mr-20'"
            >
                <p
                    v-if="templateLabel"
                    class="font-weight-semi-bold font--16"
                >
                    {{ ucfirst(templateLabel) }}
                </p>

                <div class="d-flex align-items-center justify-content-between">
                    <input-text
                        v-model:value="groupCode"
                        :placeholder="$t('slotools.groupCode')"
                        class="w-100 mr-20"
                        size="small"
                    />

                    <base-button
                        class="w-100"
                        :disabled="!groupCode"
                        type="button"
                        @click="downloadGroupTemplate"
                    >
                        {{ $t("slotools.downloadGroupTemplate") }}
                    </base-button>
                </div>
            </div>

            <div
                class="position-relative"
                :class="$mq.sMinus ? 'w-100' : 'w-50'"
            >
                <p
                    v-if="inputLabel"
                    class="font-weight-semi-bold font--16"
                >
                    {{ ucfirst(inputLabel) }}
                </p>

                <upload-button
                    v-if="!value"
                    :status="status"
                    mode="button"
                    @new-file="file => addFile(file)"
                />

                <uploaded-file
                    v-else
                    class="rounded-sm p-12 border"
                    :file="value"
                    :removable="true"
                    @remove="removeFile"
                />
            </div>
        </div>
    </div>
</template>

<script>
import urlJoin from "url-join"
import { downloadResponseFile, ucfirst } from "~/lib/utils"

import BaseButton from "~/components/buttons/BaseButton"
import InputText from "~/components/inputs/InputText"
import UploadedFile from "~/components/elements/UploadedFile"
import UploadButton from "~/components/buttons/UploadButton"

export default {
    inject: ["error"],

    props: {
        status: Object,
        description: String,
        template: Object,
        value: Object,
        showTemplate: Boolean,
        templateLabel: String,
        inputLabel: String,
    },

    emits: ["update:value"],

    data() {
        return {
            groupCode: "",
        }
    },

    methods: {
        addFile(file) {
            this.$emit("update:value", file)
        },

        removeFile() {
            this.$emit("update:value", null)
        },

        async downloadGroupTemplate() {
            try {
                const response = await this.$http.fetch(
                    urlJoin(this.template.endpoint, `${this.groupCode}`)
                )
                await downloadResponseFile({
                    response,
                    fileName: `${this.$t("slotools.groupCode")} - ${this.groupCode}`,
                    t: this.$t,
                })
            } catch (error) {
                this.error(error.message)
            }
        },

        ucfirst,
    },

    components: {
        BaseButton,
        InputText,
        UploadButton,
        UploadedFile,
    },
}
</script>

<style scoped>
.instructions ul + p {
    margin-top: 20px;
}
</style>
